import React from 'react';
import FillEditor from './FillEditor';
import { useSvgAsset } from './useSvg';
import { resolveColors } from './svgColors';
import styles from './panelStyles';

/**
 * PatternPanel – pick the body pattern and recolour it.
 *
 * Props:
 *   patterns        – PATTERNS
 *   patternId       – active pattern id
 *   bodyColors      – string[]  colour per slot, shared by every pattern
 *   onPatternChange – (patternId) => void
 *   onColorChange   – (slotIndex, hex) => void
 */
export default function PatternPanel({
    patterns, patternId, bodyColors, onPatternChange, onColorChange,
}) {
    const pattern = patterns.find((p) => p.id === patternId) || null;
    const asset = useSvgAsset(pattern ? pattern.url : null);
    const colors = asset ? resolveColors(asset.slots, bodyColors) : null;

    return (
        <div style={styles.root}>
            <div>
                <div style={styles.sectionLabel}>Pattern</div>
                <div style={styles.grid3}>
                    {patterns.map((p) => (
                        <button
                            key={p.id}
                            style={styles.optionBtn(p.id === patternId)}
                            onClick={() => onPatternChange(p.id)}
                        >
                            {p.label}
                        </button>
                    ))}
                </div>
            </div>

            <FillEditor
                key={patternId}
                colors={colors}
                onChange={onColorChange}
            />
        </div>
    );
}
